import React, { useEffect, useState } from "react";
import Container from "./Container";
import Description from "./Description";
import Notes from "./Notes";
import styled from "styled-components";
import Header from "./Header";
import AssignTop from "./AssignTop";

import { default as useApiHook } from "./assets/api/UseAxios";

const DetailPage = ({ fetchedData }: { fetchedData: any }) => {
  const damage_id = fetchedData?.damage_id;
  const type = fetchedData?.type;
  // const { tableDataRerender } = useSelector((state: any) => state.globalRenderSlice);

  const endpoint =
    type === "defect"
      ? `/vehicle_maintenance/get_vehicle_defect_id_workshop/?damage_id=${damage_id}`
      : type === "breakdown"
      ? `/vehicle_maintenance/get_vehicle_breakdown_by_workshop/?breakdown_id=${damage_id}`
      : `/vehicle_maintenance/get_vehicle_defect_id_workshop/?damage_id=${damage_id}`;

  const {
    fetchData: fetchDetails,
    loading,
    data: fetchedDetails,
  } = useApiHook<{
    data: any;
  }>({
    endpoint: endpoint,
    method: "GET",
  });
  useEffect(() => {
    if (damage_id) fetchDetails();
  }, [damage_id]);
  const {
    fetchData: fetchResourcesData,

    data: fetchedResourcesDeta,
  } = useApiHook<{
    data: any;
  }>({
    endpoint: `/s3/resource/get-file_by_pass/?resource_type=${"defect"}&item_ids=${damage_id}&parent_id=null`,
    method: "GET",
  });
  useEffect(() => {
    if (damage_id) fetchResourcesData();
  }, [damage_id]);
  return (
    <div
      style={{
        backgroundColor: "rgb(234, 237, 247)",
        height: "100vh",
      }}
    >
      <AssignTop fetchedData={fetchedDetails} data={fetchedResourcesDeta} />
      <Header fetchedData={fetchedDetails} data={fetchedResourcesDeta} />
      <ContentContainer>
        <div className="column">
          <Description fetchedData={fetchedDetails} />
          <Container fetchedData={fetchedResourcesDeta} loading={loading} />
        </div>
        <Notes fetchedData={fetchedDetails} />
      </ContentContainer>
    </div>
  );
};

export default DetailPage;

export const ContentContainer = styled.div`
  padding: 30px 222px;
  justify-content: center;
  gap: 15px;
  background: #f5f5f5;
  display: flex;
  .column {
    display: flex;
    flex-direction: column;
    gap: 20px;
    width: 73%;
  }
`;
